import axios from 'axios';

export default axios.create({
  baseURL: `https://myrajshree.com/result-api/index.php/`
});